import { render, staticRenderFns } from "./ChartsData.vue?vue&type=template&id=64f1ae52&scoped=true"
import script from "./ChartsData.vue?vue&type=script&lang=js"
export * from "./ChartsData.vue?vue&type=script&lang=js"
import style0 from "./ChartsData.vue?vue&type=style&index=0&id=64f1ae52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1ae52",
  null
  
)

export default component.exports